export default "__VITE_ASSET__B0JRfl$5__"